var map = {
	"./evoting-no-weight.json": 610,
	"./evoting.json": 611
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;



//////////////////
// WEBPACK FOOTER
// ./client/components/schemas ^\.\/.*\.json$
// module id = 609
// module chunks = 0